import React, {FC} from "react";
import {usePersistentState} from "../../util/usePersistentState";

export const GuestLayout: FC<{children: React.ReactNode}> = ({children}) => {
  return <div className={"flex flex-col min-h-screen bg-brand-surface text-brand-on-surface"}>
    <nav className={"bg-brand-primary text-brand-on-primary h-20 flex items-stretch justify-start"}>
      <div className={"w-6"} />
      <div className={"flex-1 flex flex-col justify-center items-start pr-6"}>
      </div>
    </nav>
    <div className={"flex-1"}>
      {children}
    </div>
  </div>
}
